import script from "./MoleculeTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTable.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTable.vue?vue&type=style&index=0&id=34c17aae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c17aae"]])

export default __exports__